/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MaterialBatchUploadDTO,
  MaterialCreateDTO,
  PiLiangGuiDangSuCaiQingQiu,
  ResponseApiIPageSuCaiLieBiaoXiangYing,
  ResponseApiListMaterialBatchUploadResultDTO,
  ResponseApiLong,
  ResponseApiMaterialDetailDTO,
  ResponseApiPiLiangGuiDangSuCaiXiangYing,
  ResponseApiVoid,
  SuCaiChaXunDTO,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class SuCaiGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags SuCaiGuanLi
   * @name BatchArchiveMaterialsUsingPost
   * @summary 批量归档素材
   * @request POST:/dsp-admin/api/material/batch/archive
   * @secure
   */
  batchArchiveMaterialsUsingPost = (
    archiveDTO: PiLiangGuiDangSuCaiQingQiu,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiPiLiangGuiDangSuCaiXiangYing, void>({
      path: `/dsp-admin/api/material/batch/archive`,
      method: "POST",
      body: archiveDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SuCaiGuanLi
   * @name BatchUploadMaterialsUsingPost
   * @summary 批量上传素材
   * @request POST:/dsp-admin/api/material/batch/create
   * @secure
   */
  batchUploadMaterialsUsingPost = (
    uploadDTO: MaterialBatchUploadDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListMaterialBatchUploadResultDTO, void>({
      path: `/dsp-admin/api/material/batch/create`,
      method: "POST",
      body: uploadDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SuCaiGuanLi
   * @name CreateMaterialUsingPost
   * @summary 创建上传素材,md5存在则返回素材ID
   * @request POST:/dsp-admin/api/material/create
   * @secure
   */
  createMaterialUsingPost = (
    createDTO: MaterialCreateDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/material/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description 分页查询素材列表，支持按资产类型、标题、状态和审核状态筛选
   *
   * @tags SuCaiGuanLi
   * @name ListMaterialsUsingPost
   * @summary 查询素材列表
   * @request POST:/dsp-admin/api/material/list
   * @secure
   */
  listMaterialsUsingPost = (
    queryDTO: SuCaiChaXunDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageSuCaiLieBiaoXiangYing, void>({
      path: `/dsp-admin/api/material/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SuCaiGuanLi
   * @name GetMaterialUsingPost
   * @summary 获取素材详情
   * @request POST:/dsp-admin/api/material/{id}
   * @secure
   */
  getMaterialUsingPost = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiMaterialDetailDTO, void>({
      path: `/dsp-admin/api/material/${id}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SuCaiGuanLi
   * @name UpdateMaterialUsingPut
   * @summary 更新素材
   * @request PUT:/dsp-admin/api/material/{id}
   * @secure
   */
  updateMaterialUsingPut = (
    createDTO: MaterialCreateDTO,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/material/${id}`,
      method: "PUT",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SuCaiGuanLi
   * @name DeleteMaterialUsingDelete
   * @summary 归档素材
   * @request DELETE:/dsp-admin/api/material/{id}
   * @secure
   */
  deleteMaterialUsingDelete = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/material/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new SuCaiGuanLi();
